import { Box } from "@primer/react";
import { useContext, useEffect } from "react";
import { ILayoutContext, LayoutContext } from "../../layout/Layout";
import ChartDoanhThuTheoKhoi from "./ChartDoanhThuTheoKhoi";
import ChartDoanhThuTheoHinhThucThanhToan from "./ChartDoanhThuTheoHinhThucThanhToan";
import ChartCongNoPieChart from "./ChartCongNoPieChart";

const ThongKePage = () => {
  const { setHideSubNav } = useContext<ILayoutContext>(LayoutContext);
  useEffect(() => {
    if (setHideSubNav) {
      setHideSubNav(true);
    }
    return () => {
      if (setHideSubNav) {
        setHideSubNav(false);
      }
    };
  }, []);
  return (
    <Box
      sx={{
        backgroundColor: "#EFF2F4",
        minHeight: `${window.innerHeight - 90}px`,
        p: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        {/* Phần tiêu đề */}
        <Box
          sx={{ fontWeight: "500", fontSize: 18, color: "#666", textAlign: "center" }}
        >
          Dashboard Thống kê & Báo cáo
        </Box>

        {/* Hàng đầu tiên - 2 biểu đồ doanh thu */}
        <Box>
          <Box
            sx={{ fontWeight: "500", fontSize: 16, color: "#666", mb: 2, textAlign: "center" }}
          >
            Thống kê doanh thu
          </Box>
          <Box
            sx={{
              display: "grid",
              gap: 3,
              gridTemplateColumns: "1fr 1fr", // Chia đôi màn hình
              minHeight: "500px"
            }}
          >
            {/* Biểu đồ cột - Doanh thu theo khối (bên trái) */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <ChartDoanhThuTheoKhoi />
            </Box>

            {/* Biểu đồ tròn - Doanh thu theo hình thức thanh toán (bên phải) */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <ChartDoanhThuTheoHinhThucThanhToan />
            </Box>
          </Box>
        </Box>

        {/* Hàng thứ hai - Biểu đồ công nợ */}
        <Box>
          <Box
            sx={{ fontWeight: "500", fontSize: 16, color: "#666", mb: 2, textAlign: "center" }}
          >
            Phân tích công nợ
          </Box>
          <Box
            sx={{
              minHeight: "500px"
            }}
          >
            {/* Biểu đồ công nợ - chiếm toàn bộ width như 2 biểu đồ trên */}
            <ChartCongNoPieChart />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ThongKePage;
